<template>
  <section class="page-login">
    <div class="container">
      <div class="row mt-5 flex-row-reverse">
        <div class="col-12 col-md-6 offset-0 offset-md-3">
          <div class="mt-5 panel-card">
            <m-login/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MLogin from "cp/login.vue";

export default {
  name: "page-login",
  components: {
    MLogin
  }
};
</script>

<style lang="less">
.page-login {
  height: calc(100%);
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue